module.exports = __webpack_public_path__ + "static/media/logo-black.9b68f796.png";